import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles((theme) => ({
  UPTCPUserMessageWrapper: {
    marginTop: theme.spacing(1.5)
  },
  ErrorDialogPaper: {
    borderRadius: 0
  },
  ErrorDialogContent: {
    padding: '0 !important',
    position: 'relative',
    '& .MuiAlert-root': {
      [theme.breakpoints.down('xs')]: {
        paddingRight: theme.spacing(6)
      }
    }
  },
  ErrorDialogClose: {
    position: 'absolute',
    zIndex: 10,
    right: theme.spacing(1),
    top: theme.spacing(0),
    color: theme.palette.primary.dark
  },
  linkCompanyErrorMessage: {
    // paddingRight: 50,
    padding: theme.spacing(1, 7, 1.25, 2),
    whiteSpace: 'pre-line'
  }
}))
